import { useEffect } from 'react';
import styles from './footer.module.css'
import '../../styles/global.css'

function Footer() {
  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={`${styles.wrapper} container`}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <img src='/images/newlife.png' alt='Trung tâm Du học Hàn Quốc New Life' />
            <h3>Trung tâm Du học Hàn Quốc New Life</h3>
          </div>
          <div className={styles.infor_detail}>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/address.svg' alt='Địa chỉ' />
              <div>TRỤ SỞ CHÍNH: Số 9, 58C phố Xuân Nương, 6C phường Nông Trang, thành phố Việt Trì, tỉnh Phú Thọ</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/address.svg' alt='Địa chỉ' />
              <div>CHI NHÁNH HÀN QUỐC: Tầng 4, số 32 Bangulaen-ro, Mapo-gu, Seoul, Hàn Quốc</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/address.svg' alt='Địa chỉ' />
              <div>CHI NHÁNH THÁI BÌNH: Quang Trung, Hưng Hà, Thái Bình</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/address.svg' alt='Địa chỉ' />
              <div>CHI NHÁNH VĨNH PHÚC: Đê Hến, Bá Hiến, Bình Xuyên, Vĩnh Phúc</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/hotline.svg' alt='Hotline' />
              <div>HOTLINE: 0984.498.256 - 02103.993.995</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/email.svg' alt='Email' />
              <div>EMAIL: newlifecompany.pt@gmail.com - ptth061283@gmail.com</div>
            </div>
            <div className={styles.contact}>
              <img className={styles.icon} src='/icons/facebook.svg' alt='Facebook' />
              <div>FANPAGE: Trung tâm Du học Hàn Quốc New Life</div>
            </div>
          </div>
        </div>
        <div className={styles.facebook}>
          <iframe
            title="Facebook Page"
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fphungthuhong1983&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
            width="340"
            height="130"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          >
            <a href="https://www.facebook.com/phungthuhong1983">
              Trung Tâm Du Học Hàn Quốc New Life
            </a>
          </iframe>
        </div>
      </div>
      <div className={styles.copyright}>
        © 2026 New Life Education Center. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;